<psrs-detail-display [route]="route" [label]="label" [state]="state">
  <h1>{{ cnt.label }}</h1>
  <psrs-inline-pdf [PdfFile]="cnt"> </psrs-inline-pdf>
</psrs-detail-display>
